import { render } from "./KeywordSearch.vue?vue&type=template&id=23b5d658"
import script from "./KeywordSearch.vue?vue&type=script&lang=js"
export * from "./KeywordSearch.vue?vue&type=script&lang=js"

import "./KeywordSearch.vue?vue&type=style&index=0&id=23b5d658&lang=scss"

import exportComponent from "/app/tmp/alangray/V3/v2026.32.r0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__